import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, change, focus } from 'redux-form';
import { RenderField, RenderTextareaField, RenderHiddenField, RenderSubmitButton } from '../../../common/form';
import * as Validations from '../../../common/form/commonValidations';
import { addFaq, updateFaq, getSuggestedFaqs } from '../../../../actions/website/entities/FaqActions';
import { hideModal } from '../../../../actions/ModalActions';

class FaqForm extends React.Component {
  constructor(props) {
    super(props);
    this.switchCommonQs = this.switchCommonQs.bind(this);
    this.selectQuestion = this.selectQuestion.bind(this);
    this.state = {
      commonQs: false,
    };
  }

  componentDidMount() {
    const { getSuggestions } = this.props;
    getSuggestions();
  }

  switchCommonQs() {
    this.setState({ commonQs: !this.state.commonQs });
  }

  selectQuestion(question) {
    const { setFaq } = this.props;
    if (question) {
      setFaq(question);
    }
    this.setState({ commonQs: false });
  }

  render() {
    const { handleSubmit, pristine, submitting, valid, commonQuestions, isUpdate } = this.props;

    return (
      <div id="faq-form">
        {!this.state.commonQs &&
          <div className="entity-form">
            <div className="modal-header">
              <h3 className="modal-title">{isUpdate ? 'Edit' : 'Add'} FAQ</h3>
            </div>
            <div className="modal-body">
              <span className="text-button" onClick={this.switchCommonQs} role="button">See most common questions used by Zola couples &rsaquo;</span>
              <br />
              <br />
              <form onSubmit={handleSubmit} noValidate>
                <Field
                  name="question"
                  id="faq-form-question"
                  label="Question"
                  type="text"
                  component={RenderField}
                  maxChars={400}
                  validate={[Validations.REQUIRED, Validations.MAX_LENGTH_400]}
                  required
                />
                <Field
                  name="answer"
                  id="faq-form-answer"
                  label="Answer"
                  component={RenderTextareaField}
                  validate={[Validations.REQUIRED, Validations.MAX_LENGTH_1000]}
                  maxChars={1000}
                  required
                />
                <Field
                  component={RenderHiddenField}
                  name="suggested_faq_id"
                />
                <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid} />
              </form>
            </div>
          </div>
        }
        {this.state.commonQs &&
          <div className="entity-form">
            <div className="modal-header">
              <span className="text-button back-button" onClick={this.selectQuestion}><i className="zolaicon zolaicon-chevron-left" /> back</span>
              <h3 className="modal-title">Most Common Questions Used By Zola Couples</h3>
            </div>
            <div className="modal-body">
              <ul className="common-faqs list-unstyled">
                {commonQuestions && commonQuestions.map((question, idx) => (
                  <li className="common-faq" role="button" onClick={() => this.selectQuestion(question)} key={idx}>
                    {question.question}
                    <span className="text-button pull-right">Select &rsaquo;</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        }
      </div>
    );
  }
}

FaqForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  setFaq: PropTypes.func.isRequired,
  getSuggestions: PropTypes.func.isRequired,
  commonQuestions: PropTypes.arrayOf(PropTypes.shape({})),
  isUpdate: PropTypes.bool,
};

const FaqFormInstance = reduxForm({
  form: 'faqForm'
})(FaqForm);

const mapStateToProps = state => ({
  initialValues: state.website.entities.byId[state.website.entities.selectedEntityId],
  commonQuestions: state.website.entities.suggestions
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (faqFormRequest) => {
    if (faqFormRequest.id) {
      dispatch(updateFaq(faqFormRequest));
    } else {
      dispatch(addFaq(faqFormRequest));
    }
    dispatch(hideModal());
  },
  shouldValidate: params => params.fieldValidatorKeys.length > 0,
  setFaq: (question) => {
    dispatch(focus('faqForm', 'question'));
    dispatch(change('faqForm', 'question', question.question));
    dispatch(change('faqForm', 'suggested_faq_id', question.id));
  },
  getSuggestions: () => dispatch(getSuggestedFaqs())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FaqFormInstance);



/** WEBPACK FOOTER **
 ** ./src/components/manage/website/entities/FaqForm.jsx
 **/